import React, { useState } from "react";
import "./OrdersTable.css";
import { Link } from "react-router-dom";

const OrdersTable = (props) => {
  const orders = props.Orders

  const columns = {
    orderId: "Order ID",
    date: "Date Created",
    orderStatus: "Order Status",
    total: "Total",
    actions: "", // Empty column for action buttons
  };

  const [selectedOrder, setSelectedOrder] = useState(null);

  const renderHead = () => {
    return (
      <>
        <tr>
          {Object.values(columns).map((colName) => (
            <th key={colName}>{colName}</th>
          ))}
        </tr>
      </>
    );
  };
  //   <>
  //   <tr>
  //     <th colSpan={2}>Items Orderd</th>
  //     <th colSpan={3}>Shipping Address</th>
  //   </tr>

  //   <tr>
  //     <td colSpan={2}>
  //       <tr>
  //         <th>Orderd Items</th>
  //       </tr>

  //       <tr>
  //         <th>Order Status</th>
  //         <th>Payment Method</th>
  //       </tr>
  //     </td>
  //     <td colSpan={3}>
  //       {/* Render dropdown content here
  //         <strong>Order Details </strong>
  //         <br />
  //         {/* Render dropdown content here */}
  //       {/* <strong>Shipping Address</strong> */}
  //     </td>
  //   </tr>
  // </>
  const renderRows = () => {
    console.log(orders);
    return orders.map((order) => (
      <React.Fragment key={order.id}>
        <tr onClick={() => setSelectedOrder(order)}>
          <td data-label={"Order ID"}>{order.id}</td>
          <td data-label={"Date"}>
            {new Date(order.createdAt).toLocaleDateString()}
          </td>
          <td data-label={"Order Status"}>{order.orderStatus}</td>
          <td data-label={"Total"}>${order.TotalAmount}</td>
          <td>
            <button>View</button>
          </td>
        </tr>
        {selectedOrder && selectedOrder.id === order.id && (
          <>
            <tr>
              <td>
                <tr>
                  <th>Orderd Items</th>
                </tr>
                {order.items.map((item) => (
                  <tr>
                    <a href={`/product/${item.id}`} style={{ width: "100%" }}>
                      <td className="items">
                        {item.name} x {item.qty}
                      </td>
                    </a>
                  </tr>
                ))}
                <tr id="orderstatus">
                  <th>Order Status</th>
                  <th>Payment Method</th>
                  {order.paidUsing !== "COD" ? <th>Payment Status</th> : <></>}
                </tr>
                <tr>
                  <td data-label={"Order Status "}> {order.orderStatus}</td>
                  <td data-label={"Payment Method "}>{order.paidUsing}</td>
                  {order.paidUsing !== "COD" ? (
                    <td data-label={"Payment Status "}>
                      {order.paymentStatus}
                    </td>
                  ) : (
                    <></>
                  )}
                </tr>
              </td>
              <td colSpan={4} data-label={"Shipping address"}>
                {/* Render dropdown content here
                <strong>Order Details </strong>
                <br />
                {/* Render dropdown content here */}
                {/* <strong>Shipping Address</strong> */}
                <td>
                  {order.address.name ? (
                    <>
                      {order.address.name}
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  {order.address.number ? <>{order.address.number} </> : ""}
                  {order.address.street ? <>{order.address.street} </> : ""}
                  {order.address.city ? <>{order.address.city} </> : ""}
                  {order.address.state ? <>{order.address.state} </> : ""}
                  {order.address.country ? <>{order.address.country} </> : ""}
                  {order.address.pincode ? <>{order.address.pincode} </> : ""}
                  {order.address.phoneNumber ? (
                    <>
                      <br />
                      <strong>Ph No: </strong>
                      {order.address.phoneNumber}
                    </>
                  ) : (
                    ""
                  )}
                  <td>
                    {order.paymentStatus === "pending" ? (
                      <>
                        <Link to={`/payments/paypal/process/${order.id}`}>
                          <button className="btn btn-primary">
                            Make Payment
                          </button>
                        </Link>
                      </>
                    ) : (
                      <></>
                    )}
                  </td>
                </td>
              </td>
            </tr>
          </>
        )}
      </React.Fragment>
    ));
  };

  return (
    <div>
      <h2>Orders</h2>
      <table className="responsive-table">
        <thead>{renderHead()}</thead>
        <tbody>{renderRows()}</tbody>
      </table>
    </div>
  );
};

export default OrdersTable;
